import { render } from "./ChatArea.vue?vue&type=template&id=5a27a68f&scoped=true&ts=true&lang=pug"
import script from "./ChatArea.vue?vue&type=script&lang=ts"
export * from "./ChatArea.vue?vue&type=script&lang=ts"

import "./ChatArea.vue?vue&type=style&index=0&id=5a27a68f&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a27a68f"]])

export default __exports__